<div
  class="instruction-icon-component"
  [ngClass]="icon ? 'with-icon' : 'no-icon'"
>
  <div class="icon-wrapper" *ngIf="icon">
    <dgx-components-icon
      [icon]="icon"
      [name]="icon"
      size="md"
    ></dgx-components-icon>
  </div>
  <div
    [innerHTML]="sanitizedDescription"
    class="description"
    [ngClass]="icon ? 'with-icon-description' : 'no-icon-description'"
  ></div>
</div>
